import {ModuleWithProviders}      from '@angular/core';
import {RouterModule, Routes}     from '@angular/router';
import {LoginGuard, InitialRoutesProvider}               from '@synisys/idm-ui-shell';
import {LoginPagePreventionGuard} from '@synisys/idm-ui-shell/app/services/login-page-prevention-guard';

export const appRouting: Routes = [
  {
    path        : 'login', canActivate: [LoginPagePreventionGuard],
    loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('./login/login.module')['LoginModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  }, 'LoginModule');}) },
  },
  {
    path: 'registration',
    loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('@synisys/idm-user-data-ui')['RegistrationModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  });}) }
  },
  {
    path: 'resetpassword',
    loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('@synisys/idm-user-data-ui/app/resetPassword/reset-password.module')['ResetPasswordModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  }, 'ResetPasswordModule');}) },
  },
  {
    path: 'expiredpassword',
    loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('@synisys/idm-user-data-ui')['ExpiredPasswordModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  });}) }
  },
  {
    path        : 'ssoprelogin',
    loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('@synisys/idm-ui-shell/app/modules/sso-pre-login/sso-pre-login.module')['SSOPreLoginModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  });}) },
  },
  {
    path        : '',
    canLoad     : [LoginGuard],
    loadChildren: function() { return new Promise(function (resolve, reject) {  (require as any).ensure([], function (require: any) {    resolve(require('./shell/main.shell.module')['MainShellModule']);  }, function(e: any) {    reject({ loadChunkError: true, details: e });  }, 'MainShellModule');}) },
  },
];

export const appRoute: ModuleWithProviders = RouterModule.forRoot(appRouting, InitialRoutesProvider.getOptions());
